<script setup>
import { onMounted } from 'vue';
import { useNotificationsStore } from '@/store/notificationsStore';
import { storeToRefs } from "pinia";
import BaseIconButton from '@/components/BaseComponents/BaseIconButton.vue';
import BaseToast from '@/components/BaseComponents/BaseToast.vue';
import BaseNotificationCard from '@/components/BaseComponents/BaseNotificationCard.vue';

const notificationsStore = useNotificationsStore();
const { notifications, showNotifications } = storeToRefs(notificationsStore);

onMounted(() =>
{
  notificationsStore.initializeConnection();
});
</script>

<template>
  <Transition name="slide">
    <div v-if="showNotifications" class="custom-sidebar">
      <div class="notification-header">
        <h2>Meldinger</h2>
        <div class="header-buttons">
          <BaseIconButton icon="trash-can" type="danger" @click="notificationsStore.clearNotifications()" />
          <BaseIconButton icon="times" type="default" @click="notificationsStore.toggleNotifications()" />
        </div>
      </div>
      <div class="notification-list">
        <BaseNotificationCard
          v-for="notification in notifications"
          :key="notification.id"
          :notification="notification"
        />
      </div>
    </div>
  </Transition>

  <BaseToast />
</template>

<style scoped>
.custom-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 20vw;
  background-color: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  z-index: 1050;
}

/* Animasjoner */
.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.notification-list {
  padding: 1rem;
  overflow-y: auto;
  max-height: calc(100vh - 60px);
}

.header-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
</style>
